export async function tokenAuth(url: RequestInfo) {

    function validateToken(expires: number) {
        let timestamps = Math.round((new Date()).getTime() / 1000);
        return Number(timestamps) >= Number(expires);
    }

    if (validateToken(Number(localStorage.getItem('@Unisuam/expires')))) {
        await serviceAuth(url).then(response => {
            setValue(response);
        }).then(() => {
        })
    }

}

export async function serviceRefreshToken(url: RequestInfo) {

    await serviceAuth(url).then(response => {
        setValue(response);
    }).then(() => {
    })

}

function setValue(response: { success: boolean; data: { token: string; expires: string; }; }) {

    localStorage.setItem('@Unisuam/authToken', '');
    localStorage.setItem('@Unisuam/expires', '');

    if (response.success) {
        localStorage.setItem('@Unisuam/authToken', response.data.token);
        localStorage.setItem('@Unisuam/expires', response.data.expires);
    }

}

async function serviceAuth(url: RequestInfo) {

    return await fetch(url + '/token', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                'login': 'Aluno',
                'password': "jpU1mP7ixsNSQuFjHATmEdn5AX7cKQdv4ura5MKzbUc="
            }
        )
    })
        .then(response => response.json())
        .catch(err => {
            console.log(err);
        });

}